export const runeRuinRank: Record<number, { name: string; class: string }> = {
  1: {
    name: '微弱',
    class: 'normal',
  },
  2: {
    name: '朦胧',
    class: 'race',
  },
  3: {
    name: '明亮',
    class: 'epic',
  },
  4: {
    name: '闪耀',
    class: 'legend',
  },
}

export const monsterIcon = {
  nest: '👾',
  runeRuin: '🎃',
  runeTemple: '👑',
  crack: '⚫',
  wild: '💀',
  advance: '👑👑',
  goldTemple: '👑',
  relicRuin: '🎃',
  drageonMountain: '🐉',
  peak: '👑👑',
  nian: '👹'
}

export const crackRank: Record<number, { name: string; class: string }> = {
  1: {
    name: '简单',
    class: 'normal',
  },
  2: {
    name: '普通',
    class: 'race',
  },
  3: {
    name: '困难',
    class: 'epic',
  },
  4: {
    name: '噩梦',
    class: 'antiquity',
  },
}
export const goldTempleRank: Record<number, { name: string; class: string; hpMag: number }> = {
  1: {
    name: '简单',
    class: 'normal',
    hpMag: 1,
  },
  2: {
    name: '普通',
    class: 'race',
    hpMag: 1.3,
  },
  3: {
    name: '困难',
    class: 'epic',
    hpMag: 1.7,
  },
  4: {
    name: '噩梦',
    class: 'antiquity',
    hpMag: 2.6,
  },
}

export const guideFightTips = [
  '史莱姆作为各项属性均衡的低级怪物，可通过<span class="grow">铁匠铺</span>强化后轻松战胜（游戏内副本均支持离线进行）',
  '幽灵具备较高的<span class="info">闪避率</span>，因而<span class="info">命中率</span>尤为重要',
  '矮人具备较高的<span class="info">抗暴率</span>及中等的<span class="info">防御力</span>，因而装备选择应舍弃<span class="info">暴击率</span>，尽可能提升<span class="info">破防</span>',
  '软泥怪的<span class="special">特性</span>为<span class="shrink">减法降低</span>玩家的<span class="info">攻击速度</span>，因而当您的<span class="info">攻击速度</span>越高时，受其影响越小',
  '鹰身女妖的<span class="special">特性</span>为<span class="shrink">百分比降低</span>玩家的<span class="info">攻击</span>，因而采用固定伤害的特效攻击（如追击、重击）将事半功倍',
  '电元素的<span class="special">特性</span>为<span class="shrink">降低</span>非暴击攻击伤害，因而提升<span class="info">暴击率</span>尤为重要',
  '矮人首领的<span class="special">特性</span>为<span class="shrink">降低</span>暴击时伤害，应舍弃<span class="info">暴击率</span>加成装备，以规避其特性减伤',
  '翡翠蜥蜴的<span class="special">特性</span>回血，可使得您享受高额的<span class="shrink">冲锋</span>效果',
  '吸血鬼的<span class="special">特性</span>对<span class="info">命中率</span>的要求极为苛刻，尽可能将<span class="info">命中率</span>提升至不可被闪避',
  '钢铁人具备极高的<span class="info">防御</span>，此时采用<span class="real-damage">真实伤害</span>效果极佳',
]

export const drageonMountainRankHpMag: Record<number, number> = {
  1: 1,
  2: 1.4,
  3: 1.95,
}
